import { useState } from 'react';

import { AvailablePieceJointeDto } from 'lib_api/lib/api/gen';

import { useModal } from './useModal';

export const useModalWithValue = () => {
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState<AvailablePieceJointeDto | undefined>(
    undefined,
  );

  const modal = useModal();

  const open = (value: AvailablePieceJointeDto | undefined) => {
    setVisible(true);
    modal.open();
    setValue(value);
  };

  const close = () => {
    setVisible(false);
    modal.close();
  };

  return {
    visible,
    open,
    close,
    value,
  };
};
